import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

interface PageTitleProps {
  children: ReactNode
}

function PageTitle({ children }: PageTitleProps) {
  return (
    <Typography component="h1" variant="h1" sx={{ mb: 4 }}>
      {children}
    </Typography>
  )
}

export default PageTitle
